import { render, staticRenderFns } from "./CItemContact.vue?vue&type=template&id=767f0154"
import script from "./CItemContact.vue?vue&type=script&lang=js"
export * from "./CItemContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports